import { API_URL } from "config";
import Http from "util/https";
import { AmountAPISymbol, ClientResponseApi, ClientSearchApiParams, ClientStockList, StoreResponseApi, StoreStockList } from "../types/index";
import { convertSymbolAPItoClient, convertUTCToDateTimeMinutes, nullToBlank, nullToZero } from "../utils/common";

const splitSetStr = '+';

/**
 * 得意先用在庫一覧Api
 * @param params 在庫一覧Apiのパラメータ
 * @returns StoreStockList
 */
export default async function clientStockListApi(params: ClientSearchApiParams) {
  const http = Http.default.alterAuth({useToken: true});
  const url = `${API_URL}/stock/select/client`;
  const res = await http.post<ClientResponseApi>(url, params);
  // const res: {data: ClientResponseApi} = {data: {
  //   total: 15,
  //   stocks: [{
  //     item_name: "WH STA",
  //     item_code: "000001",
  //     jan_cd: "0123456789012",
  //     brand_name: "WH",
  //     size: "185/65H15R",
  //     class_name: "タイヤ",
  //     vendor_name: "ﾌﾞﾘﾁﾞｽﾄﾝ",
  //     depot_quantity: 1000,
  //   }, {
  //     item_name: "WH STA",
  //     item_code: "000001100001",
  //     jan_cd: "0123456789012",
  //     brand_name: "WH,WH2",
  //     size: "185/65H15R,15x5J +40 5H-114.3",
  //     class_name: "タイヤ",
  //     vendor_name: "-",
  //     depot_quantity: 1000,
  //   }]
  // }};

  const stockList: ClientStockList = {
    total: res.data.total,
    stocks: res.data.stocks.map((s, i) => {
      if (s.item_code.length === 6) {
        return {
          id: i + (params.offset ?? 0),
          janCd: s.jan_cd,
          productName: s.item_name ?? '',
          brand: s.brand_name ?? '',
          productCd: s.item_code,
          size: s.size ?? '',
          classification: s.class_name,
          tyreStorehouse: nullToZero(s.depot_quantity),
          supplierName: s.vendor_name,
          isDiscontinued: !!s.discontinued_flag,
        }
      }
      return {
        id: i + (params.offset ?? 0),
        janCd: s.jan_cd,
        productName: s.item_name ?? '',
        productCd: s.item_code,
        classification: "タイヤ・ホイール",
        stockSingleList: [{
          // タイヤ
          productCd: s.item_code.slice(0, 6),
          productName: s.item_name ? s.item_name.split(splitSetStr)[0] : '',
          brand: s.brand_name ? s.brand_name.split(splitSetStr)[0] : '',
          size: s.size ? s.size.split(splitSetStr)[0] : '',
          quantity: 1
        }, {
          // ホイール
          productCd: s.item_code.slice(6, 12),
          productName: s.item_name ? s.item_name.split(splitSetStr)[1] : '',
          brand: s.brand_name ? s.brand_name.split(splitSetStr)[1] : '',
          size: s.size ? s.size.split(splitSetStr)[1] : '',
          quantity: 1
        }],
        tyreStorehouse: nullToZero(s.depot_quantity),
        isDiscontinued: !!s.discontinued_flag,
      }
    }),
  };

  await new Promise<void>((resolve) => {setTimeout(resolve, 1500)});
  console.log(res);
  // return res.data;
  return stockList;
}
